import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "my-8 text-14 tablet:text-16"
}
const _hoisted_2 = {
  key: 0,
  class: "mb-8 flex items-center justify-between border-b border-black-200 pb-8 text-black-900"
}
const _hoisted_3 = { class: "flex items-center gap-x-4" }
const _hoisted_4 = { class: "flex flex-col gap-8 text-black-700" }
const _hoisted_5 = { class: "flex items-center justify-between" }
const _hoisted_6 = { id: "cartSubtotal" }
const _hoisted_7 = {
  key: 0,
  class: "flex items-center justify-between"
}
const _hoisted_8 = { class: "font-medium text-green" }
const _hoisted_9 = { class: "flex items-center justify-between tablet:border-none" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "flex items-center justify-between text-16 font-bold text-black-900" }
const _hoisted_14 = { id: "cartTotal" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_icon = _resolveComponent("v-icon")

  return ($props.cartHasItems)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        ($props.isCustomDiscountApplicable)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_v_icon, {
                  icon: "gift",
                  width: 22,
                  height: 22
                }),
                _createElementVNode("span", null, _toDisplayString($props.locale.code) + ": ", 1),
                _createElementVNode("span", {
                  class: _normalizeClass(["font-medium uppercase", $props.skeletonClass])
                }, _toDisplayString($props.formattedDiscountCode), 3)
              ]),
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[0] || (_cache[0] = (...args) => ($props.removeCustomDiscountCode && $props.removeCustomDiscountCode(...args)))
              }, [
                _createVNode(_component_v_icon, {
                  icon: "close",
                  width: 9,
                  height: 9,
                  color: "#605F5F"
                })
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", null, _toDisplayString($props.locale.subtotal), 1),
            _createElementVNode("span", _hoisted_6, _toDisplayString($props.formattedSubtotal), 1)
          ]),
          ($props.isCustomDiscountApplicable || $props.discountValue > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("span", null, _toDisplayString($props.locale.discount_total), 1),
                _createElementVNode("span", _hoisted_8, _toDisplayString($props.formattedDiscountValue), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_9, [
            ($props.isCountryAvailable)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  ($props.isShippingAmountReached)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString($props.locale.shipping_fee_reached), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString($props.locale.shipping_fee_progress), 1))
                ], 64))
              : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString($props.locale.shipping_fee_reached), 1)),
            _createElementVNode("span", {
              id: "cartShipping",
              class: _normalizeClass(["text-right", {'text-green': $props.isShippingAmountReached}])
            }, _toDisplayString($props.formattedShippingValue), 3)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("span", null, _toDisplayString($props.locale.total), 1),
            _createElementVNode("span", _hoisted_14, _toDisplayString($props.formattedTotal), 1)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}